import Reveal from '@/components/feature/Reveal';
import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-discuss-line text-sm" />
              社区讨论 · 实时更新
            </span>

            <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.2] text-foreground-950 md:text-5xl">
              找入口不用绕路
              <br />
              一步直达<span className="text-primary-600">黑料官网</span>
            </h2>

            <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
              黑料官网入口、网址、地址与直达链接在这里集中整理，无需绕路。
              本站实时更新可访问的官网首页路径，帮你解决找不到官网的困扰，
              点开即可快速进入目标页面，浏览全部内容。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#entry"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:text-base"
              >
                <i className="ri-login-box-line text-lg" />
                立即进入官网
              </a>
              <a
                href="#trending"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 md:text-base"
              >
                <i className="ri-fire-line text-lg" />
                查看今日热度榜
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-3 gap-4 border-t border-background-200/70 pt-6">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="font-heading text-xl font-bold text-primary-700 md:text-2xl">
                    {stat.value}
                  </dt>
                  <dd className="mt-1 text-xs text-foreground-600 md:text-sm">{stat.label}</dd>
                </div>
              ))}
            </dl>
          </Reveal>

          <Reveal delay={120} className="relative">
            <div className="relative h-[320px] w-full overflow-hidden rounded-lg md:h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20artwork%20with%20warm%20terracotta%20vermillion%20and%20amber%20tones%2C%20layered%20paper%20textures%2C%20soft%20cream%20background%2C%20geometric%20speech%20bubble%20shapes%2C%20minimalist%20modern%20magazine%20cover%20aesthetic%2C%20subtle%20grain%2C%20harmonious%20warm%20color%20palette%2C%20high%20detail%2C%20elegant%20composition&width=900&height=1120&seq=heilio-hero-2026&orientation=portrait"
                alt="黑料官网入口指引视觉插画"
                title="黑料官网入口 网址 地址 直达链接"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/45 via-foreground-950/5 to-transparent"></div>

              <div className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-900">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                线路正常
              </div>

              <p className="absolute bottom-5 left-5 right-5 font-heading text-lg font-semibold leading-snug text-background-50 md:text-xl">
                入口、网址、地址
                <br />
                一处集中，随时可取
              </p>
            </div>

            <div className="animate-floaty absolute -bottom-6 right-4 hidden w-56 rounded-lg border border-background-200 bg-background-50 p-4 md:block">
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-chat-smile-2-line text-base text-primary-600" />
                正在讨论
              </div>
              <p className="mt-2 font-heading text-2xl font-bold text-foreground-950">3,482</p>
              <p className="mt-1 text-[11px] text-foreground-600">今日新增讨论条数</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}